"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _FileSystemWrapper = _interopRequireDefault(require("../../../cordovaPluginWrappers/FileSystemWrapper"));

var _CordovaFileHelper = _interopRequireDefault(require("../../../helpers/CordovaFileHelper"));

var _FileReaderWriterWrapper = _interopRequireDefault(require("../../../cordovaPluginWrappers/FileReaderWriterWrapper"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

// @ts-ignore
var Image = function Image(props) {
  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      source = _useState2[0],
      setSource = _useState2[1];

  var updateSource = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(src) {
      var _window$WkWebView$con, _window$WkWebView;

      var isBrowser, isDataURL, isSVGString, prefix, filename, isSVGFile, entry, WkWebViewSource;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (src) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", null);

            case 2:
              isBrowser = _DeviceInfoHelper["default"].isBrowser();

              if (!isBrowser) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", setSource({
                type: 'img',
                src: src
              }));

            case 5:
              // This is a dataURL which may be used as a direct source for an img.
              isDataURL = src.startsWith('data:image');

              if (!isDataURL) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", setSource({
                type: 'img',
                src: src
              }));

            case 8:
              // This is a svg string, which will be rendered as a child of a div.
              isSVGString = src.includes('<svg');

              if (!isSVGString) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", setSource({
                type: 'svg',
                src: src
              }));

            case 11:
              _context.next = 13;
              return _FileSystemWrapper["default"].getPathPrefix();

            case 13:
              prefix = _context.sent;
              filename = src.replace(prefix, ''); // This is a svg file, so read its' content and render it as a child if a div.

              isSVGFile = filename.endsWith('.svg');

              if (!isSVGFile) {
                _context.next = 23;
                break;
              }

              _context.t0 = setSource;
              _context.next = 20;
              return _CordovaFileHelper["default"].readTextFile(filename);

            case 20:
              _context.t1 = _context.sent;
              _context.t2 = {
                type: 'svg',
                src: _context.t1
              };
              return _context.abrupt("return", (0, _context.t0)(_context.t2));

            case 23:
              _context.next = 25;
              return _CordovaFileHelper["default"].getFileEntry(filename);

            case 25:
              entry = _context.sent;
              // Feature flag useLocalhostFiles. Either convert to WkWebView compatible, or just use url as img source.
              WkWebViewSource = (_window$WkWebView$con = (_window$WkWebView = window.WkWebView) === null || _window$WkWebView === void 0 ? void 0 : _window$WkWebView.convertFilePath(entry.toURL())) !== null && _window$WkWebView$con !== void 0 ? _window$WkWebView$con : entry.toURL();

              if (!_config["default"].useLocalhostFiles) {
                _context.next = 29;
                break;
              }

              return _context.abrupt("return", setSource({
                type: 'img',
                src: WkWebViewSource
              }));

            case 29:
              _context.t3 = setSource;
              _context.next = 32;
              return _FileReaderWriterWrapper["default"].readFileAsDataUrl(entry);

            case 32:
              _context.t4 = _context.sent;
              _context.t5 = {
                type: 'img',
                src: _context.t4
              };
              return _context.abrupt("return", (0, _context.t3)(_context.t5));

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  (0, _react.useLayoutEffect)(function () {
    void updateSource(props.src);
  }, [props.src]);
  if ((source === null || source === void 0 ? void 0 : source.type) === 'img') return /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({}, props, {
    src: source.src
  }));
  if ((source === null || source === void 0 ? void 0 : source.type) === 'svg') return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    dangerouslySetInnerHTML: {
      __html: source.src
    }
  }, props));
  return null;
};

var _default = /*#__PURE__*/_react["default"].memo(Image);

exports["default"] = _default;